import '~/js/libs/jquery.waypoint';
import '~/js/libs/sticky';

// Variable Declaration
const resortMenu = document.getElementById('resort-menu');
const toggleButton = document.getElementById('resort-menu-click');
const isFixedNav = resortMenu.classList.contains('fixed-resort-menu');
let waypoint;

// Internals Variables
const internals = {
  options: {
    element: resortMenu,
    offset: 50,
    stuckClass: 'stuck'
  }
};

// Sticky Nav
if (!isFixedNav) {
  waypoint = new window.Waypoint.Sticky(internals.options);
}

// Toggle Sticky Nav
toggleButton.addEventListener('click', () => resortMenu.classList.toggle('open'));

document.body.addEventListener('click', (event) => {
  if (($(event.target).parents('#resort-menu').length <= 0) && (resortMenu.classList.contains('open'))) {
    resortMenu.classList.remove('open');
  }
});

const stickyNav = _.debounce(() => {
  if (window.pageYOffset <= waypoint.waypoint.triggerPoint) {
    if (window.innerWidth > 767) {
      if (resortMenu.classList.contains('stuck')) {
        resortMenu.classList.remove('stuck');
      }
    }
  }
}, 300);

window.addEventListener('resize', stickyNav);
